module.exports = __webpack_public_path__ + "fonts/licensed/tenon-regular.woff2";